<script lang="ts">
	interface Props {
		strokeWidth?: number;
		className?: string;
	}

	let { strokeWidth = 1, className = '' }: Props = $props();
</script>

<div class={className}>
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 24 24"
		stroke="currentColor"
		fill="none"
		stroke-width={strokeWidth}
	>
		<path
			d="M14.9536 14.9458L21 21M17 10C17 13.866 13.866 17 10 17C6.13401 17 3 13.866 3 10C3 6.13401 6.13401 3 10 3C13.866 3 17 6.13401 17 10Z"
		></path>
	</svg>
</div>
